import { render, staticRenderFns } from "./InterestsAchievements.vue?vue&type=template&id=6ea0a380&scoped=true&"
import script from "./InterestsAchievements.vue?vue&type=script&lang=ts&"
export * from "./InterestsAchievements.vue?vue&type=script&lang=ts&"
import style0 from "./InterestsAchievements.vue?vue&type=style&index=0&id=6ea0a380&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea0a380",
  null
  
)

export default component.exports